<template>
    <div id="Map2" style="width: 100%; height: 100%;"></div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";

// 如果你的项目使用了中国地图的 JS
// import "echarts/map/js/china.js";
import "@/utils/china.js"
import { findAllAndCount } from "@/api/home";
export default {
    name: "Map2",
    data() {
        return {
            zoom: "138%",
            myChart: null,
            center: {
                "北京市": [116.405285, 39.904989],
                "天津市": [117.190182, 39.125595],
                "河北省": [114.502461, 38.045474],
                "山西省": [112.549248, 37.857014],
                "内蒙古自治区": [111.670801, 40.818311],
                "辽宁省": [123.429096, 41.796767],
                "吉林省": [125.3245, 43.886841],
                "黑龙江省": [126.642464, 45.756967],
                "上海市": [121.472644, 31.231706],
                "江苏省": [118.767413, 32.041544],
                "浙江省": [120.153576, 30.287459],
                "安徽省": [117.283042, 31.86119],
                "福建省": [119.306239, 26.075302],
                "江西省": [115.892151, 28.676493],
                "山东省": [117.000923, 36.675807],
                "河南省": [113.665412, 34.757975],
                "湖北省": [114.298572, 30.584355],
                "湖南省": [112.982279, 28.19409],
                "广东省": [113.280637, 23.125178],
                "广西壮族自治区": [108.320004, 22.82402],
                "海南省": [110.199999, 20.033333],
                "重庆市": [106.504962, 29.533155],
                "四川省": [104.065735, 30.659462],
                "贵州省": [106.713478, 26.578383],
                "云南省": [102.712251, 25.040609],
                "西藏自治区": [91.132212, 29.660361],
                "陕西省": [108.948024, 34.263161],
                "甘肃省": [103.823557, 36.058039],
                "青海省": [101.778916, 36.623178],
                "宁夏回族自治区": [106.278179, 38.46637],
                "新疆维吾尔自治区": [87.617733, 43.792818],
                "香港特别行政区": [114.173332, 22.306927],
                "澳门特别行政区": [113.543873, 22.198951],
                "台湾省": [121.509062, 25.044332]
            },
            center2: {
                "北京市": [116.305285, 39.704989],
                "天津市": [117.090182, 39.025595],
                "河北省": [114.402461, 37.945474],
                "山西省": [112.449248, 37.757014],
                "内蒙古自治区": [111.570801, 40.718311],
                "辽宁省": [123.329096, 41.696767],
                "吉林省": [125.2245, 43.786841],
                "黑龙江省": [126.542464, 45.656967],
                "上海市": [121.372644, 31.131706],
                "江苏省": [118.667413, 31.941544],
                "浙江省": [120.053576, 30.187459],
                "安徽省": [117.183042, 31.76119],
                "福建省": [119.206239, 25.975302],
                "江西省": [115.792151, 28.576493],
                "山东省": [116.900923, 36.575807],
                "河南省": [113.565412, 34.657975],
                "湖北省": [114.198572, 30.484355],
                "湖南省": [112.882279, 28.09409],
                "广东省": [113.180637, 23.025178],
                "广西壮族自治区": [108.220004, 22.72402],
                "海南省": [110.099999, 19.933333],
                "重庆市": [106.404962, 29.433155],
                "四川省": [103.965735, 30.559462],
                "贵州省": [106.613478, 26.478383],
                "云南省": [102.612251, 24.940609],
                "西藏自治区": [90.932212, 29.560361],
                "陕西省": [108.848024, 34.163161],
                "甘肃省": [103.723557, 35.958039],
                "青海省": [101.678916, 36.523178],
                "宁夏回族自治区": [106.178179, 38.36637],
                "新疆维吾尔自治区": [87.517733, 43.692818],
                "香港特别行政区": [114.073332, 22.206927],
                "澳门特别行政区": [113.443873, 22.098951],
                "台湾省": [121.409062, 25.044332]
            },
            apiData: [
                { region: "上海市", areaAmount: 1 },
                { region: "云南省", areaAmount: 4 },
                { region: "内蒙古自治区", areaAmount: 5 },
                { region: "北京市", areaAmount: 1 },
                // 这里可以放完整的后台数据
            ]
        };
    },
    async mounted() {
        const res = await findAllAndCount()
        console.log(res.data)
        this.apiData = res.data.cloudlsdCountAreaList;

        this.initChart();
        window.addEventListener("resize", this.resizeChart);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeChart);
    },
    methods: {
        initChart() {
            this.myChart = echarts.init(document.getElementById("Map2"));

            const cities = Object.keys(this.center);
            const data = cities.map(name => {
                const item = this.apiData.find(e => e.region === name);
                return { name, value: item ? item.areaAmount : 0 };
            });

            const scatterData = data.map(item => [
                this.center[item.name][0],
                this.center[item.name][1] + item.value * 0.0001
            ]);
            const scatterData3 = data.map(item =>
                this.center2[item.name].concat(item.name)
            );

            const option = {
                title: [{
                    text: `中国综试区总数`,
                    // text:`<span style="color: red;">测试</span>`,
                    left: '33%',
                    top: '70',
                    textStyle: { //主标题 字体控制
                        color: '#F1FAFF',
                        fontSize: 28,
                        fontFamily: 'YouSheBiaoTiHei, YouSheBiaoTiHei'
                    },
                },
                {
                    // text: count,
                    text: '196',
                    left: '58%',
                    top: '74',
                    textStyle: { //主标题 字体控制
                        color: '#FFC64B',
                        fontSize: 24,
                        lineHeight: 18,
                        fontFamily: 'YouSheBiaoTiHei, YouSheBiaoTiHei'

                    },
                },
                ]
                ,
                geo: [
                    {
                        map: "china",
                        regions: [
                            { name: "南海诸岛", itemStyle: { areaColor: 'transparent', borderWidth: 0 } }
                        ],
                        aspectScale: 0.9,
                        roam: false,
                        layoutSize: this.zoom,
                        layoutCenter: ["50%", "50%"],
                        itemStyle: {
                            areaColor: "transparent",
                            borderColor: "#37C1FD",
                            borderWidth: 2
                        },
                        emphasis: {
                            itemStyle: { areaColor: "#0160AD" },
                            label: { show: false }
                        },
                        zlevel: 3
                    },
                    {
                        map: "china",
                        regions: [
                            { name: "南海诸岛", itemStyle: { areaColor: 'transparent', borderWidth: 0 } }
                        ],
                        aspectScale: 0.9,
                        roam: false,
                        layoutSize: this.zoom,
                        layoutCenter: ["50%", "50%"],
                        itemStyle: {
                            areaColor: {
                                type: "radial",
                                x: 0.7,
                                y: 0.5,
                                r: 0.4,
                                colorStops: [
                                    { offset: 0, color: "#56CCFB" },
                                    { offset: 1, color: "#0160AD" }
                                ]
                            },
                            borderColor: "#37C1FD",
                            borderWidth: 2
                        },
                        zlevel: 2,
                        silent: true
                    },
                    {

                        map: "china",
                        aspectScale: 0.9,
                        roam: false,
                        layoutSize: this.zoom,
                        layoutCenter: ["50%", "52%"],
                        itemStyle: {
                            areaColor: "#005DDC",
                            borderColor: "#329BF5",
                            borderWidth: 1
                        },
                        zlevel: 1,
                        silent: true
                    }
                ],
                series: [
                    {
                        type: "scatter",
                        coordinateSystem: "geo",
                        geoIndex: 0,
                        zlevel: 5,
                        symbol: "pin",
                        symbolSize: [10, 10],
                        label: {
                            show: true,
                            position: "top",
                            formatter: params => data[params.dataIndex].value,
                            padding: [4, 8],
                            backgroundColor: "#003F5E",
                            borderRadius: 5,
                            borderColor: "#67F0EF",
                            borderWidth: 1,
                            color: "#67F0EF",
                            fontSize: 10
                        },
                        itemStyle: { color: "#FEF03B", opacity: 1 },
                        silent: true,
                        data: scatterData
                    },
                    {
                        type: "effectScatter",
                        coordinateSystem: "geo",
                        geoIndex: 0,
                        symbol: "circle",
                        symbolSize: 2.5,
                        showEffectOn: "render",
                        rippleEffect: { brushType: "fill", scale: 10 },
                        hoverAnimation: true,
                        label: {
                            formatter: p => p.data[2],
                            position: "bottom",
                            color: "#fff",
                            fontSize: 10,
                            distance: 10,
                            show: true
                        },
                        itemStyle: { color: "#FEF134" },
                        zlevel: 6,
                        data: scatterData3
                    }
                ]
            };

            this.myChart.setOption(option);
        },
        resizeChart() {
            if (this.myChart) this.myChart.resize();
        }
    }
};
</script>